<div class="d-flex justify-content-center align-items-center p-5">
    <div class="bg-white shadow rounded p-4 w-100">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="text-dark">{{ translationService.getTranslation('Questions and Answers') }}</h3>
        <button class="btn btn-success" *ngIf="hasPermission(Permissions.AddDelete)" (click)="AddModal()">{{ translationService.getTranslation('Add New Item') }}</button>
      </div>
  
      <div class="row">
        <div class="col-2">
          <input class="form-control mb-3" autocomplete="off" [(ngModel)]="searchText" (input)="searchForItem(searchText)" placeholder="{{ translationService.getTranslation('Search by Question Content') }}"/>
        </div>
        
        <div class="col-2">
          <select class="form-control mb-3" (change)="onFolderChange($event)" [(ngModel)]="searchFolder">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Folder') }}</option>
            <option *ngFor="let folder of FolderDTO | keyvalue" [value]="folder.value.CourseName">{{ folder.value.CourseName }}</option>
          </select>
        </div>
      
        <div class="col-2">
          <select class="form-control mb-3" [(ngModel)]="searchUnit" [disabled]="!searchFolder">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Unit') }}</option>
            <option *ngFor="let unit of selectedFolderUnits;" [value]="unit.UnitName">{{ unit.UnitName }}</option>
          </select>
        </div>
      
        <div class="col-2">
          <select class="form-control mb-3" [(ngModel)]="searchType" [disabled]="!searchFolder">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Question Type') }}</option>
            <option *ngFor="let type of questionTypes" [value]="type">{{ type }}</option>
          </select>
        </div>
      
        <div class="col-2">
          <select class="form-control mb-3" [(ngModel)]="searchLevel" [disabled]="!searchFolder">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Question Level') }}</option>
            <option *ngFor="let weight of QuestionLevels" [value]="weight.name">{{ weight.name }}</option>
          </select>
        </div>
      
        <div class="col-1 text-center pt-1">
          <button class="btn btn-sm btn-warning" (click)="searchFilters()" [disabled]="!searchFolder && !searchUnit && !searchType && !searchLevel">
            {{ translationService.getTranslation('Search') }}
          </button>
        </div>

        <div class="col-1 pt-1">
          <button class="btn btn-sm btn-primary" [disabled]="!searchFolder && !searchUnit && !searchType && !searchLevel" (click)="resetFilters()">{{ translationService.getTranslation('Reset') }}</button>
        </div>
      </div>
      

<div class="table-responsive">
  <table class="table table-bordered table-striped table-hover">
    <thead class="table-success">
      <tr>
        <th scope="col">{{ translationService.getTranslation('Quetsion ID') }}</th>
        <th scope="col">{{ translationService.getTranslation('Question') }}</th>
        <th scope="col">{{ translationService.getTranslation('Question Type') }}</th>
        <th scope="col">{{ translationService.getTranslation('Question Level') }}</th>
        <th scope="col">{{ translationService.getTranslation('Folder Name') }}</th>
        <th scope="col">{{ translationService.getTranslation('Folder Unit') }}</th>
        <!-- <th scope="col">{{ translationService.getTranslation('Form Number') }}</th> -->
        <th scope="col">{{ translationService.getTranslation('Language') }}</th>
        <th scope="col">{{ translationService.getTranslation('Action') }}</th>              
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let question of qusetionBank">
        <td>{{ question.ID }}</td>
        <td>{{ question.Question }}</td>
        <td>{{ question.QuestionType }}</td>
        <td>{{ question.QuestionLevel }}</td>
        <td>{{ question.FolderName }}</td>
        <td>{{ question.FolderUnit}}</td>
        <!-- <td>{{ question.FormNo}}</td> -->
        <td>
          <select class="form-select form-control" name="language" (change)="changeLanguage(question)" [ngModelOptions]="{standalone: true}" [(ngModel)]="question.Language">
            <option *ngFor="let language of filteredLanguagesList" [value]="language.LanguageName">{{ language.LanguageName }}</option>
          </select>
        </td>
        <td class="text-center">
          <i class="bi bi-eye text-primary me-2" (click)="viewQuestion(question)" style="cursor: pointer;"></i>
          <i class="bi bi-pencil-square text-secondary me-2" (click)="updateModal(question)" style="cursor: pointer;"></i>
          <i class="bi bi-trash text-danger me-2" *ngIf="hasPermission(Permissions.AddDelete)" (click)="deleteQuestionItem(question)" style="cursor: pointer;"></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>
  
<div class="d-flex justify-content-between align-items-center mt-3">
  <div>
    {{ translationService.getTranslation('Showing') }} 
    {{ qusetionBank.length }} 
    {{ translationService.getTranslation('of') }} 
    {{ TotalQuestions }} 
    {{ translationService.getTranslation('Questions') }}
  </div>
  <nav>
    <ul class="pagination m-0">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link text-success bg-white border-success mx-2" (click)="prevPage()">
          {{ translationService.getTranslation('Previous') }}
        </button>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link text-success bg-white border-success" (click)="nextPage()">
          {{ translationService.getTranslation('Next') }}
        </button>
      </li>
    </ul>
  </nav>
</div>

<div class="container">
    
  <div *ngIf="showAddModal" class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showAddModal ? 'false' : 'true'">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ translationService.getTranslation('Add New Item') }}</h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
          <form name="formAddQuestion" #addQuestionForm="ngForm">

            <div class="row">
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Question ID') }}</label>
                <input type="text" class="form-control" autocomplete="off" name="id" disabled />
              </div>
          
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Folder Name') }}</label>
                <select class="form-control" (change)="onFolderChange($event)" [(ngModel)]="formAddQuestion.FolderName" name="folderName">
                  <option value="" disabled selected>{{ translationService.getTranslation('Select Folder') }}</option>
                  <option *ngFor="let folder of FolderDTO" [value]="folder.CourseName">{{ folder.CourseName }}</option>
                </select>
              </div>
              
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Folder Unit') }}</label>
                <select class="form-control" [(ngModel)]="formAddQuestion.FolderUnit" name="folderUnit">
                  <option value="" disabled selected>{{ translationService.getTranslation('Select Unit') }}</option>
                  <option *ngFor="let unit of selectedFolderUnits;" [value]="unit.UnitName">{{ unit.UnitName }}</option>
                </select>
              </div>
            </div>
          
            <div class="row mt-3">
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Question Type') }}</label>
                <select class="form-control" (change)="onQuestionTypeChange($event)" [(ngModel)]="formAddQuestion.QuestionType" name="type">
                  <option disabled selected>{{ translationService.getTranslation('Select Type') }}</option>
                  <option *ngFor="let type of questionTypes" [value]="type">{{ type }}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Language') }}</label>
                <input type="text" class="form-control" autocomplete="off" value="{{ translationService.getTranslation('Arabic') }}" name="language" disabled />
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ translationService.getTranslation('Question Level') }}</label>
                <select class="form-control" [(ngModel)]="formAddQuestion.QuestionLevel" name="Weight">
                  <option value="" disabled selected>{{ translationService.getTranslation('Select Weight') }}</option>
                  <option *ngFor="let weight of QuestionLevels" [value]="weight.name">{{ weight.name }}</option>
                </select>
              </div>
              <!-- <div class="col-md-3">
                <label class="form-label">{{ translationService.getTranslation('Select Form Number') }}</label>
                <input type="number" class="form-control" min="1" max="8" [(ngModel)]="formAddQuestion.FormNo" name="formNumber"/>
              </div>                            -->
            </div>
          
            <div class="row mt-3 align-items-center" >
              <div class="col-md-9 d-flex align-items-center">
                <label class="form-label mx-2">{{ translationService.getTranslation('Question Content') }}</label>
                <input type="text" class="fw-bold form-control w-75" autocomplete="off" [(ngModel)]="formAddQuestion.QuestionText" name="content" required />
              </div>
              <div class="col-md-3 d-flex justify-content-start" >

                <button type="button" class="btn btn-secondary m-2" disabled>
                  <i class="bi bi-mic"></i>
                </button>

                <input  type="file" #fileInput hidden (change)="handleFileInput($event, 'image')" accept="image/*" />
                <input type="file" #videoInput hidden (change)="handleFileInput($event, 'video')" accept="video/*" />

                <button *ngIf="showQuestionImage" type="button" class="btn btn-outline-success m-2" (click)="fileInput.click()">
                  <i class="bi bi-image"></i>
                </button>

                <button *ngIf="showQuestionVideo" type="button" class="btn btn-outline-warning m-2" (click)="videoInput.click()">
                  <i class="bi bi-camera-video"></i>
                </button>

              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 d-flex gap-3">
                <div *ngIf="formAddQuestion.ImageLink">
                  <img src="{{getImageLink + this.formAddQuestion.ImageLink}}" class="img-thumbnail" style="width: 450px; height: 250px;" />
                </div>
                <div *ngIf="formAddQuestion.VideoLink">
                  <video controls class="img-thumbnail" style="width: 450px; height: 250px;">
                    <source src="{{getVideoLink + this.formAddQuestion.VideoLink}}" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <h6>{{ translationService.getTranslation('Answers') }}</h6>
                <div *ngIf="selectedQuestionType === 'Ordering'" class="alert alert-danger text-center" role="alert">
                  <b>
                    ملاحظة: يرجى كتابة الترتيب الصحيح للاجوبة من البداية      
                  </b>   
                </div>
                <div class="list-group">
                  <div *ngFor="let answer of AnswersDTO; let i = index" class="list-group-item p-2">
                    <div class="d-flex align-items-center">
                      <span *ngIf="selectedQuestionType === 'Ordering'" class="badge text-bg-success p-2 mx-2">{{ i + 1 }}</span>
                      <div *ngIf="selectedQuestionType !== 'Ordering'" class="form-check form-switch m-2">
                        <input class="form-check-input custom-checkbox" type="checkbox" id="IsCorrect{{ i }}" [(ngModel)]="answer.IsCorrect" name="IsCorrect" [ngModelOptions]="{standalone: true}" />
                      </div>
                      <input type="text" *ngIf="showAnswerText" class="fw-bold form-control m-2" autocomplete="off" [(ngModel)]="answer.AnswerText" name="answerText" [ngModelOptions]="{standalone: true}" />
                      <div *ngIf="answer.ImageLink">
                        <img src="{{getImageLink + answer.ImageLink}}" class="img-thumbnail" [ngModelOptions]="{standalone: true}" />
                      </div>
                      <button *ngIf="showRemoveBTN" type="button" class="btn btn-danger m-2" (click)="removeAnswer()">
                        <i class="bi bi-trash"></i>
                      </button>
                      <button  *ngIf="showAnswerImage" type="button" class="btn btn-outline-success m-2" (click)="fileInput.click()">
                        <i class="bi bi-image"></i>
                      </button>
                      <input type="file" #fileInput hidden (change)="handleFileInput($event, 'image', i)" accept="image/*" />
                      <button  *ngIf="showAnswerVideo" type="button" class="btn btn-outline-warning m-2" (click)="videoInput.click()">
                        <i class="bi bi-camera-video"></i>
                      </button>
                      <input type="file" #videoInput hidden (change)="handleFileInput($event, 'video', i)" accept="video/*" />
                    </div>
                  </div>
                </div> 
                <div *ngIf="showAddBTN">
                  <button type="button" class="btn btn-success mt-3" (click)="addAnswer()">
                    <i class="bi bi-plus-circle"></i> {{ translationService.getTranslation('Add Answer') }}
                  </button>
                </div>                           
              </div>
            </div>
            
          
            <div class="modal-footer mt-4">
              <button type="button" class="btn btn-secondary" (click)="closeModal()">
                {{ translationService.getTranslation('Cancel') }}
              </button>
              <button type="button" class="btn btn-success" [disabled]="isFormInvalid()" (click)="AddQuestionItem(formAddQuestion)">
                {{ translationService.getTranslation('Add Question') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
    
  <div *ngIf="showUpdateModal" class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showUpdateModal ? 'false' : 'true'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ translationService.getTranslation('Edit Item') }}</h5>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <form>
                  <div class="row">
                    <div class="col-md-4">
                        <label class="form-label">{{ translationService.getTranslation('Question ID') }}</label>
                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.ID" name="parentid" disabled/>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label">{{ translationService.getTranslation('Language') }}</label>
                      <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.Language" name="language" disabled/>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label">{{ translationService.getTranslation('Folder Name') }}</label>
                      <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.FolderName" name="FolderName" disabled/>
                    </div>
                  </div>
                  
                  <div class="row my-3">
                      <div class="col-md-4">
                        <label class="form-label">{{ translationService.getTranslation('Folder Unit') }}</label>
                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.FolderUnit" name="FolderUnit" disabled/>
                      </div>
                      <div class="col-md-4">
                          <label class="form-label">{{ translationService.getTranslation('Question Type') }} </label>
                          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.QuestionType" name="QuestionType" disabled/>
                      </div>
                      <div class="col-md-4">
                          <label class="form-label">{{ translationService.getTranslation('Question Level') }}</label>
                          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.QuestionLevel" name="QuestionLevel" disabled/>
                      </div>
                      <!-- <div class="col-md-3">
                        <label class="form-label">{{ translationService.getTranslation('Select Form Number') }}</label>
                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="selectedQuestion.FormNo" name="FormNo" disabled/>
                      </div>  -->
                  </div>

                
                  <div class="row mt-3 align-items-center">
                      <div class="col d-flex align-items-center">
                          <label class="form-label">{{ translationService.getTranslation('Question Content') }}</label>
                          <input type="text" class="fw-bold form-control" autocomplete="off" [(ngModel)]="selectedQuestion.Question" name="content" required />
                      </div>
                      <div *ngIf="selectedQuestion.Language === 'Arabic'" class="col-md-4 d-flex justify-content-start">
                        <input type="file" #fileInput hidden (change)="handleFileInput($event, 'image')" accept="image/*" />
                        <input type="file" #videoInput hidden (change)="handleFileInput($event, 'video')" accept="video/*" />
        
                        <button *ngIf="showQuestionImage" type="button" class="btn btn-outline-success m-2" (click)="fileInput.click()">
                          <i class="bi bi-image"></i>
                        </button>
        
                        <button *ngIf="showQuestionVideo" type="button" class="btn btn-outline-warning m-2" (click)="videoInput.click()">
                          <i class="bi bi-camera-video"></i>
                        </button>
                      </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-12 d-flex gap-3">
                      <div *ngIf="selectedQuestion.ImageLink">
                        <img src="{{getImageLink + this.selectedQuestion.ImageLink}}" class="img-thumbnail" style="width: 450px; height: 250px;" />
                      </div>
                      <div *ngIf="selectedQuestion.VideoLink">
                        <video controls class="img-thumbnail" style="width: 450px; height: 250px;">
                          <source src="{{getVideoLink + this.selectedQuestion.VideoLink}}" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                      <h6>{{ translationService.getTranslation('Answers') }}</h6>
                      <div class="list-group">
                        <div *ngFor="let answer of AnswersDTO; let i = index" class="list-group-item p-2">
                          <div class="d-flex align-items-center">
                            <span *ngIf="selectedQuestion.QuestionType === 'Ordering'" class="badge text-bg-success p-2 mx-2">{{ i + 1 }}</span>
                            <div class="form-check form-switch m-2" *ngIf="selectedQuestion.QuestionType !== 'Ordering'">
                              <input class="form-check-input custom-checkbox" type="checkbox" id="IsCorrect{{ i }}"
                                [(ngModel)]="answer.IsCorrect" name="IsCorrect_{{i}}" [ngModelOptions]="{standalone: true}"
                                [disabled]="selectedQuestion.Language !== 'Arabic'" />
                            </div>
                            <input type="text" class="fw-bold form-control m-2" autocomplete="off"
                              [(ngModel)]="answer.AnswerText" name="answerText_{{i}}" [ngModelOptions]="{standalone: true}" />
                      
                              <div *ngIf="answer.ImageLink">
                                <img src="{{getImageLink + answer.ImageLink}}" class="img-thumbnail" [ngModelOptions]="{standalone: true}" />
                              </div>
                              <button *ngIf="showAnswerImage" type="button" class="btn btn-outline-success m-2" (click)="fileInput.click()">
                                <i class="bi bi-image"></i>
                              </button>
                              <input type="file" #fileInput hidden (change)="handleFileInput($event, 'image', i)" accept="image/*" />
                              <button *ngIf="showAnswerVideo" type="button" class="btn btn-outline-warning m-2" (click)="videoInput.click()">
                                <i class="bi bi-camera-video"></i>
                              </button>
                              <input type="file" #videoInput hidden (change)="handleFileInput($event, 'video', i)" accept="video/*" />
                            </div>
                          </div>
                        </div> 
                    
                        <div *ngIf="showAddBTN">
                          <button type="button" class="btn btn-success mt-3" (click)="addAnswer()">
                            <i class="bi bi-plus-circle"></i> {{ translationService.getTranslation('Add Answer') }}
                          </button>
                        </div>                           
                      </div>
                    </div>

            <div class="modal-footer mt-4">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ translationService.getTranslation('Cancel') }}</button>
                <button type="submit" class="btn btn-success" [disabled]="isUpdateFormInvalid()" (click)="updateQuestionItem()">{{ translationService.getTranslation('Update Question') }}</button>
                
            </div>

          </form>
            </div>
        </div>
    </div>
  </div>

  <div *ngIf="showViewModal" class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showViewModal ? 'false' : 'true'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-success text-white">
                <h5 class="modal-title"><i class="bi bi-eye"></i> {{ translationService.getTranslation('View Question') }}</h5>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <table class="table table-bordered table-striped">
                  <tr>
                      <th class="p-2"><i class="bi bi-file-earmark-text"></i> {{ translationService.getTranslation('Question ID') }}</th>
                      <td>{{ selectedQuestion.ID }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-folder"></i> {{ translationService.getTranslation('Folder Name') }}</th>
                      <td>{{ selectedQuestion.FolderName }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-box"></i> {{ translationService.getTranslation('Folder Unit') }}</th>
                      <td>{{ selectedQuestion.FolderUnit }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-file-earmark-code"></i> {{ translationService.getTranslation('Question Type') }}</th>
                      <td>{{ selectedQuestion.QuestionType }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-globe"></i> {{ translationService.getTranslation('Language') }}</th>
                      <td>{{ selectedQuestion.Language }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-circle"></i> {{ translationService.getTranslation('Question Level') }}</th>
                      <td>{{ selectedQuestion.QuestionLevel }}</td>
                  </tr>
                  <tr>
                      <th class="p-2 "><i class="bi bi-chat-text"></i> {{ translationService.getTranslation('Question Content') }}</th>
                      <td class="fw-bold">{{ selectedQuestion.Question }}
                        <i 
                        class="bi bi-volume-up text-success" 
                        role="button" 
                        (click)="playAudio(selectedQuestion.Question, selectedQuestion.Language)"
                        style="cursor: pointer; font-size: 1.1rem;">
                      </i>
                      </td>
                  </tr>
              </table>                
                <h6 *ngIf="selectedQuestion.ImageLink || selectedQuestion.VideoLink" class="text-success"><i class="bi bi-camera-video"></i> {{ translationService.getTranslation('Media') }}:</h6>
                <div class="row mt-3">
                  <div class="col-md-12 d-flex gap-3">
                    <div *ngIf="selectedQuestion.ImageLink">
                      <img src="{{getImageLink + this.selectedQuestion.ImageLink}}" class="img-thumbnail" style="width: 450px; height: 250px;" />
                    </div>
                    <div *ngIf="selectedQuestion.VideoLink">
                      <video controls class="img-thumbnail" style="width: 450px; height: 250px;">
                        <source src="{{getVideoLink + this.selectedQuestion.VideoLink}}" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
                <h6 class="text-success"><i class="bi bi-pencil-square"></i> {{ translationService.getTranslation('Answers') }}:</h6>
                <div class="list-group">
                  <div *ngFor="let answer of AnswersDTO; let i = index" class="list-group-item d-flex justify-content-between align-items-center p-2">
                    <span class="fw-bold">
                      <span *ngIf="this.selectedQuestion.QuestionType === 'Ordering'" class="badge text-bg-success p-2 mx-2">{{ i+1 }}</span>
                      <i *ngIf="answer.IsCorrect === true" class="bi bi-check-circle"></i>
                      {{ answer.AnswerText }}
                      <i 
                      class="px-2 bi bi-volume-up text-success" 
                      role="button" 
                      (click)="playAudio(answer.AnswerText, selectedQuestion.Language)"
                      style="cursor: pointer; font-size: 1.3rem;">
                    </i>
                      <div *ngIf="answer.ImageLink">
                        <img src="{{getImageLink + answer.ImageLink}}" class="img-thumbnail" style="width: 250px; height: 250px;" />
                      </div>
                    </span>
                  </div>                                                                                           
                </div>                  
            </div>
        </div>
    </div>
  </div>

  <div *ngIf="showDeleteModal"  class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showDeleteModal ? 'false' : 'true'">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ translationService.getTranslation('Confirm Deletion?') }}</h5>
        </div>
        <div class="modal-body">
          {{ translationService.getTranslation('Are you sure you want to delete this Question?') }}
          <br>
          {{this.selectedQuestion.Question}}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ translationService.getTranslation('Cancel') }}</button>
          <button type="button" class="btn btn-danger" (click)="confirmDeletion()" *ngIf="hasPermission(Permissions.AddDelete)">{{ translationService.getTranslation('Delete') }}</button>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="isUploading" class="modal fade show" tabindex="-1" role="dialog" style="display: block; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1060;">
    <div class="modal-dialog" role="document" style="max-width: 300px;">
      <div class="modal-content">
        <div class="modal-body text-center">
          <div class="text-success" role="status" style="font-size: 50px;">
            <span><i class="bi bi-hourglass-top"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
</div>
